/*
 * File: /src/services/agencyService.js
 * Created Date: Thursday April 2nd 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 2nd April 2020 5:09:20 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_AGENCY_PATH } from '../constants';

export default {
  /**
   * Simulate Client
   *
   * @param {*} id
   * @returns
   */
  simulateClient(id) {
    if (isNaN(+id)) return;
    return authedAxios.get(AD_BASE_AGENCY_PATH + 'simulate/' + +id).then(r => {
      return r;
    });
  },

  /**
   * Fetch all Users for Company
   *  - Admin only. will return 500 unless so.
   *
   * @param {*} id
   * @param {*} meta
   * @returns
   */
  fetchAllUsers(id, meta) {
    return authedAxios.get(AD_BASE_AGENCY_PATH + 'company/' + +id).then(r => {
      return r;
    });
  },

  /**
   * Drop Company ID
   * - Admin Only. will return 500 unless so.
   *
   * @param {*} companyId
   * @param {*} userId
   * @returns
   */
  dropUserAccount(companyId, userId) {
    return authedAxios
      .delete(AD_BASE_AGENCY_PATH + 'company/' + companyId + '/' + userId)
      .then(r => {
        return r;
      });
  },

  /**
   * Add Company ID to User
   * - Admin Only. will return 500 unless so.
   *
   * @param {*} companyId
   * @param {*} userId
   * @returns
   */
  addAgencyCompanyToUser(companyId, userId) {
    return authedAxios
      .post(AD_BASE_AGENCY_PATH + 'company/' + companyId + '/' + userId)
      .then(r => {
        return r;
      });
  },

  /**
   * Save / Update Account
   *
   * @param {*} id
   * @param {*} meta
   * @returns
   */
  saveAccount(id, meta) {
    return authedAxios.put(AD_BASE_AGENCY_PATH + 'company/' + +id, meta).then(r => {
      return r;
    });
  },

  /**
   * New Company
   *
   * @param {*} meta
   * @returns
   */
  newAccount(meta) {
    return authedAxios.post(AD_BASE_AGENCY_PATH + 'company/', meta).then(r => {
      return r;
    });
  },

  /**
   * Drop Account
   *
   * @param {*} companyId
   * @returns
   */
  dropAccount(companyId) {
    return authedAxios
      .delete(AD_BASE_AGENCY_PATH + 'company/' + companyId)
      .then(r => {
        return r;
      });
  },

  /**
   * Get Users By Company
   *
   * @param {*} id
   * @returns
   */
  listUsersByCompany(id) {
    return authedAxios
      .get(AD_BASE_AGENCY_PATH + 'company/' + +id + '/users/')
      .then(r => {
        return r;
      });
  },

  /**
   * Get User By Id
   *
   * @param {*} coId
   * @param {*} id
   * @returns
   */
  fetchUserById(coId, id) {
    return authedAxios
      .get(
        AD_BASE_AGENCY_PATH + 'company/' + parseInt(coId, 10) + '/users/' + id
      )
      .then(r => {
        return r;
      });
  }
};
